module.exports = {"150921106":"卓资山镇","150921107":"旗下营镇","150921108":"卓资县十八台镇","150921109":"卓资县巴音锡勒镇","150921110":"卓资县梨花镇","150921210":"卓资县大榆树乡","150921211":"卓资县红召乡","150921212":"卓资县复兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150921.json
// module id = 421
// module chunks = 0